import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "192",
  height: "192",
  fill: "#f40101",
  viewBox: "0 0 256 256"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "256",
      height: "256",
      fill: "none"
    }, null, -1),
    _createElementVNode("line", {
      x1: "72",
      y1: "216",
      x2: "216",
      y2: "216",
      fill: "none",
      stroke: "#f40101",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1),
    _createElementVNode("path", {
      d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
      fill: "none",
      stroke: "#f40101",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "16"
    }, null, -1)
  ])))
}
export default { render: render }